import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ArrowRightIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function Guarantee() {
  return <section className="bg-warm-white py-20 md:py-28" data-id="element-76">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-78">
          <div className="inline-flex items-center justify-center w-32 h-32 rounded-full bg-gold/10 border-4 border-gold mb-8" data-id="element-79">
            <div className="text-center" data-id="element-80">
              <ShieldCheckIcon className="w-12 h-12 text-gold mx-auto mb-2" data-id="element-81" />
              <p className="font-serif text-2xl font-bold text-gold" data-id="element-82">60 DÍAS</p>
            </div>
          </div>

          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-charcoal mb-8" data-id="element-83">
            Mi Garantía de "Cero Riesgo"
          </h2>

          <div className="bg-cream p-8 md:p-12 rounded-lg shadow-lg max-w-2xl mx-auto mb-12" data-id="element-84">
            <p className="text-lg md:text-xl text-charcoal leading-relaxed" data-id="element-85">
              Prueba el sistema por <strong data-id="element-86">60 días completos</strong>. Si no
              sientes que tu energía se duplica y tu ropa te queda mejor,
              envíanos un email y te devolvemos cada centavo.
            </p>
            <p className="text-lg md:text-xl text-charcoal leading-relaxed mt-6" data-id="element-87">
              <strong data-id="element-88">Sin preguntas, sin resentimientos.</strong>
            </p>
            <p className="text-xl md:text-2xl font-serif text-gold mt-6 font-semibold" data-id="element-89">
              El riesgo es 100% mío.
            </p>
          </div>

          <motion.a href="#final-cta" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full lg:w-auto bg-forest text-warm-white px-8 py-5 rounded-md text-base md:text-lg font-semibold inline-flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transition-shadow" data-id="element-90">
            SÍ, QUIERO RECUPERAR MI CUERPO Y MI ENERGÍA — ACCESO INMEDIATO POR
            $7.39
            <ArrowRightIcon className="w-5 h-5" data-id="element-91" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}